import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './RegistrableClassroomAnalysis.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function RegistrableClassroomAnalysis() {	
	const navigate = useNavigate();
	
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [data, setData] = useState([]);
	
	const fetchData = async () => {
		
		getData('classroomApi/listAllGroupUsageSummaryFromToday', navigate)
		.then(res => {
				setData(res.data);			
			
				setFetchCompleted(true);
			}
		);
	}
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
		<div className={s.rowHolder}>
			<div>TG Id</div>
			<div style={{flexBasis:"200px"}}>Start Date</div>
			<div style={{flexBasis:"200px"}}>Teacher</div>
			<div style={{flexBasis:"200px"}}>Students</div>
		</div>
	
		{
			data.map((d, indexD)=>(<div key={indexD} className={s.rowHolder} style={(indexD % 2 == 0) ? {background:"#dae6e8"} :{}}>
				<div>{d.tutorGroupId}</div>
				<div style={{flexBasis:"200px"}}>{modifiedDate(d.startDate)}</div>
				<div style={{flexBasis:"200px"}}>({d.teacherId}){d.teacherUsername}</div>
				<div style={{flexBasis:"500px", display:"flex"}}>
					{
						d.students.map((s, indexS)=>(<div key={indexS} 
							style={{background:"#c3e9fa", width:"300px", fontSize:"1rem", margin:"5px", padding:"2px", borderRadius:"5px"}}>
							<div style={{display:"flex"}}>
								<div>({s.id})</div>
								{
									(s.phone) ? <div>{s.phone}</div> : <div style={{color:"#fc523b"}}>NO PHONE</div>
								}
								<div style={{margin:"0 0 0 auto"}}>{s.organizationId}</div>
							</div>
							<div style={{display:"flex"}}>
								<div>{s.nickname}</div>
							</div>
						</div>))
					}
				</div>
			</div>))
		}
	</div>);
	
}

